import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPauseWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8,
	height: 10,
	viewBox: "0 0 8 10",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 3,
		height: 10,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 5,
		y: 0,
		width: 3,
		height: 10,
		fill: "currentColor"
	})]
});
export default SvgIconPauseWhite;
